import { render } from "./EditorPage.vue?vue&type=template&id=efe996ea&scoped=true&ts=true"
import script from "./EditorPage.vue?vue&type=script&lang=ts"
export * from "./EditorPage.vue?vue&type=script&lang=ts"

import "./EditorPage.vue?vue&type=style&index=0&id=efe996ea&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe996ea"]])

export default __exports__